import { RegisterOptions } from 'react-hook-form';

export const emailValidationRule = {
  required: 'Email is required.',
  pattern: {
    value:
      /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/,
    message: 'Enter a valid email address.',
  },
} satisfies RegisterOptions;

export const usernameValidationRule = {
  required: 'Username is required.',
  minLength: {
    value: 2,
    message: 'Username must be minimum 2 characters long',
  },
  pattern: {
    value: /^[a-zA-Z0-9\-_.]+$/,
    message: 'Username is invalid. Please use only letters, numbers, underscores (_), dashes (-) and dots (.)',
  },
} satisfies RegisterOptions;

export const userGroupValidationRule = {
  required: true,
  validate: {
    isValidRole: (role: string): boolean | string => {
      const validRoles = new Set([
        'testers',
        'tester',
        'qa',
        'tester / qa',
        'tester/qa',
        'developers',
        'developer',
        'platform engineer',
        'platform engineers',
        'admins',
        'admin',
        'owner',
        'owners',
        'everyone',
        'all',
        'team',
      ]);

      return validRoles.has(role.toLowerCase()) || 'Invalid role.';
    },
  },
} satisfies RegisterOptions;

const WorkspaceNameIsRequired = 'A name is required.';
export const WorkspaceNameIsTooShortErrorMessage = 'Workspace name must be at least 2 characters';
export const WorkspaceNameIsTooLongErrorMessage = 'Workspace name cannot be longer than 40 characters';
export const WorkspaceNameIsAlreadyInUseErrorMessage = 'Workspace name is already in use';
export const workspaceNameValidationRule = {
  required: WorkspaceNameIsRequired,
  minLength: { value: 2, message: WorkspaceNameIsTooShortErrorMessage },
  maxLength: { value: 40, message: WorkspaceNameIsTooLongErrorMessage },
} satisfies RegisterOptions;

export const tokenNameValidationRule = {
  required: 'Name is required',
  pattern: {
    value: /^[a-zA-Z0-9\-_. ]+$/,
    message: 'Token name is invalid. Please use only letters, numbers, underscores (_), dashes (-) and dots (.)',
  },
} satisfies RegisterOptions;

export const urlValidationRule = {
  required: true,
  validate(value: string): boolean | string {
    try {
      const url = new URL(value);
      return /^https?:$/g.test(url.protocol) || 'Invalid URL';
    } catch {
      return 'Invalid URL';
    }
  },
} satisfies RegisterOptions;
